






// Components types
//   Entities



































//    Input Options























// Data types

/**
 * Optional prop for the renderEntity function to pass some unique custom components to the form.
 */
















































// An abstract interface that contains all the fields that are shared among all the input options of all types.





















































































































































































































































// Form entities interfaces









// An abstract interface that contains all the fields that are shared among all the entities of all types.




































































export var FormStatuses;(function (FormStatuses) {FormStatuses["COMPLETE"] = "COMPLETE";FormStatuses["NOT_YET_COMPLETED"] = "NOT_YET_COMPLETED";FormStatuses["STARTED"] = "STARTED";})(FormStatuses || (FormStatuses = {}));
//# sourceMappingURL=dynamicFormTypings.js.map